
import AppHeader from "@saleor/components/AppHeader";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { ShopInfo_shop_permissions } from "@saleor/components/Shop/types/ShopInfo";
import { PermissionSiteErrorFragment } from "@saleor/fragments/types/PermissionSiteErrorFragment";
import { SubmitPromise } from "@saleor/hooks/useForm";
import { sectionNames } from "@saleor/intl";
import { MembersListUrlSortField } from "@saleor/permissionSite/urls";
import { ListActions, SortPage } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import {
  PermissionSiteDetails_permissionSite,
  PermissionSiteDetails_permissionSite_users
} from "../../types/PermissionSiteDetails";
import PermissionSiteMemberList from "../PermissionSiteMemberList";

export interface PermissionSiteDetailsPageFormData {
  name: string;
  isActive: boolean;
  users: PermissionSiteDetails_permissionSite_users[];
}

export interface PermissionData extends ShopInfo_shop_permissions {
  lastSource?: boolean;
  disabled?: boolean;
}

export interface PermissionSiteDetailsPageProps
  extends ListActions,
    SortPage<MembersListUrlSortField> {
  disabled: boolean;
  errors: PermissionSiteErrorFragment[];
  members: PermissionSiteDetails_permissionSite_users[];
  membersModified: boolean;
  permissionSite: PermissionSiteDetails_permissionSite;
  saveButtonBarState: ConfirmButtonTransitionState;
  onAssign: () => void;
  onBack: () => void;
  onUnassign: (ids: string[]) => void;
  onSubmit: (data: PermissionSiteDetailsPageFormData) => SubmitPromise;
}

const PermissionSiteDetailsPage: React.FC<PermissionSiteDetailsPageProps> = ({
  disabled,
  errors,
  members,
  membersModified,
  onBack,
  onSubmit,
  permissionSite,
  saveButtonBarState,
  ...listProps
}) => {
  const intl = useIntl();

  const initialForm: PermissionSiteDetailsPageFormData = {

    isActive: false,
    name: permissionSite?.name || "",
    users: members
  };


  return (
    <Form initial={initialForm} onSubmit={onSubmit} confirmLeave>
      {({ data, submit, hasChanged }) => (
        <Container>
          <AppHeader onBack={onBack}>
            {intl.formatMessage(sectionNames.configuration)}
          </AppHeader>
          <PageHeader title={permissionSite?.name} />

         
          <div>
              
              <PermissionSiteMemberList
                disabled={disabled}
                {...listProps}
                users={data?.users || []}
              />
          </div>
   
          
          <div>
            <SaveButtonBar
              onCancel={onBack}
              onSave={submit}
              state={saveButtonBarState}
              disabled={disabled || !(hasChanged || membersModified)}
            />
          </div>
        </Container>
      )}
    </Form>
  );
};
PermissionSiteDetailsPage.displayName = "PermissionSiteDetailsPage";
export default PermissionSiteDetailsPage;
